import { memo, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorScreen as BaseErrorScreen } from '@/js/libs/error-boundary';

interface ErrorScreenProps {
  className?: string;
  error: Error;
}

export const ErrorScreen: FC<ErrorScreenProps> = memo(function ErrorScreen({ className, error }) {
  const [t] = useTranslation(['backend', 'common', 'components']);

  return <BaseErrorScreen className={className} error={error} title={t('components:APP_ERROR')} />;
});
